export default __webpack_public_path__ + "static/media/444.119dd161.gif";